import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './assets/scss/index.scss';
import axios from 'axios';

/**
 * Settings
 */
const tagManagerArgs = {
	gtmId: 'GTM-MDJ5F4T',
};
TagManager.initialize(tagManagerArgs);
//axios.defaults.withCredentials
//axios.defaults.withCredentials = true;

//xios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
//axios.defaults.headers.common['Access-Control-Allow-Credentials'] = 'true';



axios.defaults.withCredentials = true;

ReactDOM.render(
	//<React.StrictMode>
	<App />,
	//</React.StrictMode>
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
